export enum ProductLabelDimensions {
  _60x18 = '60x18',
  _60x18s3 = '60x18s3',
  _38x21 = '38x21',
  _45x8 = '45x8',
}
